import BootstrapTable from './src/bootstrap-table';
import withContext from './src/contexts';

export default withContext(BootstrapTable);
